import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

import constants from 'constants/index'

const DocumentFilters = ({
  filter,
  currentTab,
  categories = [],
  loadingCategories = false,
}) => {
  const { CATEGORY_OPTIONS, STATUS_OPTIONS, DOCUMENT_TEMPLATES_CATEGORY_ID } =
    constants.documents

  const isTemplateTab = currentTab === DOCUMENT_TEMPLATES_CATEGORY_ID

  if (isTemplateTab) {
    return (
      <Filters filter={filter} alphabeticalOrder alphabeticalFieldOrder="name">
        <input textfieldinput="true" label="Nome" name="name" />
        <select
          label="Categoria"
          name="documentCategoryId"
          autocompleteselectinput="true"
          optionvalues={categories}
          loading={loadingCategories}
        />
      </Filters>
    )
  }

  return (
    <Filters filter={filter} alphabeticalOrder alphabeticalFieldOrder="title">
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Título" name="title" />
      <select textfieldinput="true" label="Categoria" name="category">
        <option value=""></option>
        {CATEGORY_OPTIONS?.map((category) => (
          <option key={category.id} value={category.id}>
            {category.name}
          </option>
        ))}
      </select>
      <select
        textfieldinput="true"
        label="Canal de atendimento"
        name="publicDocument"
      >
        <option value=""></option>
        <option value={true}>Publicados</option>
        <option value={false}>Não publicados</option>
      </select>
      <select
        textfieldinput="true"
        label="Coleta de aceites"
        name="collectAccepted"
      >
        <option value=""></option>
        <option value={true}>Coletando</option>
        <option value={false}>Não coletando</option>
      </select>
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        {STATUS_OPTIONS.map((status) => (
          <option key={status?.id} value={status?.id}>
            {`${status?.name}s`}
          </option>
        ))}
      </select>
    </Filters>
  )
}

DocumentFilters.propTypes = {
  filter: PropTypes.object.isRequired,
  currentTab: PropTypes.string,
  categories: PropTypes.array,
  loadingCategories: PropTypes.bool,
}

export default DocumentFilters
